module.exports = __webpack_public_path__ + "imgs/gift-bow.f02f19ff8dbf429d00edb931a9c53b3d.svg";